import React from 'react';
import Gallery from '../components/Gallery';
import { adsImages } from '../data/images';

const Ads = () => {
  return (
    <div className="gallery-page">
      <section 
        className="hero-half"
        style={{
          backgroundImage: `url('/images/dvi-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1>Advertising Photography</h1>
          <p>
            Creative advertising photography and videography that brings your brand to life with compelling visual stories. 
            From product photography to commercial campaigns, we create impactful visual content.
          </p>
        </div>
      </section>
      
      <section className="gallery-section">
        <div className="container">
          <Gallery images={adsImages} sectionId="ads" />
        </div>
      </section>

    </div>
  );
};

export default Ads;
